<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/institution-list">会员风采</router-link></li>
                <li><router-link :to="`/layout/company-list?page=${page}`">企业风采</router-link></li>
                <li class="currentNode">
                    <a>{{ companyName }}</a>
                </li>
            </ul>
            <div class="page-main">
                <div class="page-main-tp">
                    <img :src="logo" />
                    <div class="brief-introduction">
                        <h3>{{ companyName }}</h3>
                        <p class="subtitle"><span>主营业务：</span>{{ companyAsset }}</p>
                        <!-- <p class="contact-people">
                            <span>公司联系人：</span
                            ><a @click="viewContactPhone"
                                >****** （点击查看公司联系人信息）</a
                            >
                        </p>
                        <button>加入协会</button> -->
                    </div>
                </div>
                <div class="page-main-btm">
                    <h4>公司简介</h4>
                    <el-divider></el-divider>
                    <div class="content-detail" v-html="content"></div>
                    <h3>工作动态</h3>
                    <el-divider></el-divider>
                    <el-table
                        stripe
                        :data="tableData"
                        style="width: 100%"
                        :show-header="false"
                        class="stripe-table"
                    >
                        <el-table-column label="内容">
                            <template slot-scope="scope">
                                <a class="table_a" @click="goDetail(scope.row)">
                                    <p class="ellipsis_one">
                                        <span class="dot"></span>
                                        <span>{{ scope.row.Title }}</span>
                                    </p>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="UpdateTime"
                            label="日期"
                            width="120"
                        >
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                    <!-- <p>2022年，中兴通讯进入战略超越期，中兴通讯在作为第一曲线的CT业务稳步固本同时，积极打造公司增长第二曲线，包括IT（包括服务器及存储等IT基础设施以及5G行业，汽车电子等数字化转型业务），数字能源（包括电源、IDC数据中心、新能源等），终端（包括手机、移动互联、智慧家庭等）等领域。中兴通讯成立了矿山、冶金钢铁、东数西算、汽车电子等行业特战队，加快5G垂直应用深度拓展 [122]。</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCompanyDetail, getCompanynWork } from '@services/indexService.js';

export default {
    name: '',
    data() {
        return {
            detailId: '',
            page: '',
            companyName: '',
            companyAsset: '',
            logo: '',
            contactPhone: '',
            content: '',
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            publishTime: '',
        };
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page;
        this.getCompanyDetail(this.detailId);
        this.getCompanynWork(this.detailId);
    },
    methods: {
        viewContactPhone() {},
        getCompanyDetail(id) {
            let params = {
                id: id,
            };
            getCompanyDetail(params).then((res) => {
                console.log(res);
                if (
                    res.Code === 1 &&
                    res.Data !== null &&
                    res.Data.length !== 0
                ) {
                    this.publishTime = res.Data.UpdateTime;
                    this.companyName = res.Data.CompanyName;
                    this.companyAsset = res.Data.CompanyAsset;
                    this.logo = res.Data.Logo;
                    this.contactPhone = res.Data.ContactPhone;
                    this.content = res.Data.ShopIntroduction;
                } else {
                    this.$message.error('协会要问请求失败');
                }
            });
        },
        getCompanynWork() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                id: this.detailId,
            };
            getCompanynWork(params).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.tableData = [];
                    this.$message.error('工作动态求失败');
                }
            });
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getCompanynWork();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/share-info-item-detail',
                query: {
                    id: data.Id
                }
            });
            window.open(newUrl.href, '_blank');
        }
    },
};
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
.page-main-tp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.page-main-tp img {
    width: 167px;
    height: 167px;
    border: 1px solid #e5e5e5;
}
.brief-introduction {
    margin-left: 30px;
}
.brief-introduction h3 {
    font-size: 26px;
    color: #262626;
    margin-bottom: 20px;
}
.brief-introduction h3 {
    text-align: left;
}
.brief-introduction p:last-of-type {
    margin-bottom: 20px;
}
.brief-introduction button {
    width: 129px;
    height: 30px;
    line-height: 30px;
    background: #116eba;
    color: #fff;
    text-align: center;
    outline: 0;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    box-sizing: border-box;
    border: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    font-size: 14px;
}
.contact-people a {
    cursor: pointer;
}
.contact-people a:hover {
    color: #116eba;
}
.page-main-btm h4 {
    color: #262626;
    font-size: 22px;
    margin: 20px 0;
}
</style>